$(() => {
  if($('[data-component="enable-after-selection"]').length > 0) {

    $('.selector').on('change', function(e){
      // get data-select-id
      var select_id = $(e.target).data('select-id');

      // enable affectors
      $('.affector[data-select-id=' + select_id + ']').each( function(){
        if ($(this).data('required') != 'exclude') {
          $(this).prop('required', true);
        }
        $(this).prop('disabled', false);
        $(this).removeClass('disabled');
      });

      // disable non-selected components
      $('.affector[data-select-id!=' + select_id + ']').each( function(){
        $(this).prop('required', false);
        $(this).prop('disabled', true);
        $(this).addClass('disabled');
      });
    });

  }
});
